import { render, staticRenderFns } from "./BlockType.vue?vue&type=template&id=14d0a622&scoped=true"
import script from "@/components/request/RequestDetail/block-type/BlockType.ts?vue&type=script&lang=ts&external"
export * from "@/components/request/RequestDetail/block-type/BlockType.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/request/RequestDetail/block-type/block-type.scss?vue&type=style&index=0&id=14d0a622&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d0a622",
  null
  
)

export default component.exports